var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentLesson
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "course-lesson-page container-fix-padding",
            attrs: { fluid: "" },
          },
          [
            _vm.currentLesson.lesson.isExam
              ? _c(
                  "div",
                  { staticClass: "w-100" },
                  [
                    _vm.currentLesson.lesson.examId
                      ? _c("IframeLoading", {
                          staticClass: "w-100 embed-exam vh-100",
                          attrs: {
                            id: "lesson-exam-embed",
                            src:
                              "/embed/exams/" + _vm.currentLesson.lesson.examId,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "d-flex",
                    staticStyle: { "flex-wrap": "wrap" },
                    attrs: { id: "classroom-lesson-body" },
                  },
                  [
                    _c(
                      "multipane",
                      {
                        staticStyle: { flex: "1" },
                        attrs: { layout: "vertical" },
                      },
                      [
                        _c("div", { staticClass: "lesson-pane" }, [
                          !_vm.currentLesson.lesson.isExam &&
                          _vm.getBanner("lesson_top")
                            ? _c("div", { staticClass: "d-flex" }, [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getBanner("lesson_top").bodyHtml
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "position-relative" }, [
                            !_vm.currentLesson.lesson.isText
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-lesson-detail bg-white d-flex flex-column overflow-hidden",
                                    staticStyle: { height: "35vw" },
                                  },
                                  [
                                    _vm.currentLesson && _vm.lazyLoading
                                      ? [
                                          [
                                            _vm.currentLesson.lesson.video
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "youtube-video h-full w-full",
                                                  },
                                                  [
                                                    _c("video-wrapper", {
                                                      attrs: {
                                                        player: "youtube",
                                                        videoId:
                                                          _vm.currentLesson
                                                            .lesson.video,
                                                        options: {
                                                          responsive: true,
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.currentLesson.lesson.vimeo
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "vimeo-video h-full w-full",
                                                  },
                                                  [
                                                    _c("video-wrapper", {
                                                      attrs: {
                                                        player: "vimeo",
                                                        videoId:
                                                          _vm.currentLesson
                                                            .lesson.vimeo,
                                                        options: {
                                                          responsive: true,
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.getBanner("lesson_bottom")
                                      ? [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getBanner("lesson_bottom")
                                                  .bodyHtml
                                              ),
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-lesson-detail bg-white d-flex flex-column overflow-auto",
                                  },
                                  [
                                    _vm.currentLesson && _vm.lazyLoading
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "tutorial-box" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "w-100 text-center",
                                                },
                                                [
                                                  _vm.currentLesson.lesson
                                                    .imageUrl
                                                    ? _c("img", {
                                                        staticClass: "my-0",
                                                        attrs: {
                                                          src: _vm.currentLesson
                                                            .lesson.imageUrl,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "section",
                                                { staticClass: "container" },
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass: "h3 fv-blod",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.currentLesson
                                                              .lesson.name
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "container",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row align-items-center",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-12 col-lg-5",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-md-flex align-items-center flex-wrap",
                                                                },
                                                                _vm._l(
                                                                  _vm
                                                                    .currentLesson
                                                                    .lesson
                                                                    .teachers,
                                                                  function (
                                                                    teacher
                                                                  ) {
                                                                    return _c(
                                                                      "TeacherView",
                                                                      {
                                                                        key: teacher.id,
                                                                        staticClass:
                                                                          "p-1",
                                                                        attrs: {
                                                                          teacher:
                                                                            teacher,
                                                                        },
                                                                      }
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-12 col-lg-7",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex justify-content-center justify-content-lg-end",
                                                                },
                                                                [
                                                                  !_vm
                                                                    .currentLesson
                                                                    .isLearnt
                                                                    ? _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2",
                                                                          attrs:
                                                                            {
                                                                              outlined:
                                                                                "",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              _vm.finishLesson,
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  outlined:
                                                                                    "",
                                                                                  left: "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                mdi-check-circle\n                              "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                              学習を完了する\n                            "
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _vm
                                                                    .currentLesson
                                                                    .isLearnt
                                                                    ? _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2",
                                                                          attrs:
                                                                            {
                                                                              outlined:
                                                                                "",
                                                                              color:
                                                                                "success",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              _vm.revertFinishLesson,
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  left: "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                mdi-check-circle\n                              "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                              学習完了をもどす\n                            "
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "btn-group btn-group-sm bg-secondary align-items-center",
                                                                      attrs: {
                                                                        role: "group",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "btn btn-secondary pe-3",
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.upVote()
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "bi bi-hand-thumbs-up pe-1",
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "d-none d-md-inline",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "わかりやすい"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                                " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .currentLesson
                                                                                  .lesson
                                                                                  .voteValues
                                                                              ) +
                                                                              "\n                              "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "btn btn-secondary border-start ps-2",
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.downVote()
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "bi bi-hand-thumbs-down",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.currentLesson.lesson.mdBody
                                                ? _c("div", {
                                                    staticClass: "p-4",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.currentLesson.lesson
                                                          .mdBody
                                                      ),
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.getBanner("lesson_bottom")
                                      ? [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getBanner("lesson_bottom")
                                                  .bodyHtml
                                              ),
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                            _vm._v(" "),
                            !_vm.currentLesson.lesson.isText
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-center position-absolute w-full h-full d-flex justify-space-between align-center",
                                    staticStyle: {
                                      "pointer-events": "none",
                                      "padding-right": "0px",
                                      top: "0",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "move-btn v-btn v-btn--contained theme--dark",
                                        staticStyle: {
                                          "pointer-events": "auto",
                                        },
                                        attrs: {
                                          disabled: _vm.disabledPreviousBtn,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.previousLession()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "v-btn__content material-icons",
                                          },
                                          [_vm._v("navigate_before")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "move-btn v-btn v-btn--contained theme--dark",
                                        staticStyle: {
                                          "pointer-events": "auto",
                                        },
                                        attrs: {
                                          disabled: _vm.disabledNextBtn,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goNextLesson()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "v-btn__content material-icons",
                                          },
                                          [_vm._v("navigate_next")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.currentLesson.lesson.isText
                            ? _c(
                                "div",
                                { staticClass: "text-center pt-5 py-1" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "white--text me-2",
                                      attrs: {
                                        color: "cyan",
                                        disabled: _vm.disabledPreviousBtn,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.previousLession()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              前のレッスン\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "white--text",
                                      attrs: {
                                        color: "cyan",
                                        disabled: _vm.disabledNextBtn,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goNextLesson()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              次のレッスン\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "bg-white mt-4 mb-1 p-2",
                              staticStyle: { "min-height": "25vw" },
                            },
                            [
                              _c("section", { staticClass: "container" }, [
                                _c("h2", { staticClass: "h3 fv-blod" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.currentLesson.lesson.name) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "container" }, [
                                  _c(
                                    "div",
                                    { staticClass: "row align-items-center" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-12 col-lg-5" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-md-flex align-items-center flex-wrap",
                                            },
                                            _vm._l(
                                              _vm.currentLesson.lesson.teachers,
                                              function (teacher) {
                                                return _c("TeacherView", {
                                                  key: teacher.id,
                                                  staticClass: "p-1",
                                                  attrs: { teacher: teacher },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-12 col-lg-7 px-0" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center justify-content-lg-end",
                                            },
                                            [
                                              [
                                                !_vm.currentLesson.isLearnt
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: { outlined: "" },
                                                        on: {
                                                          click:
                                                            _vm.finishLesson,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              outlined: "",
                                                              left: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            mdi-check-circle\n                          "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                          学習を完了する\n                        "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.currentLesson.isLearnt
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          outlined: "",
                                                          color: "success",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.revertFinishLesson,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: { left: "" },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            mdi-check-circle\n                          "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                          学習完了をもどす\n                        "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "btn-group btn-group-sm bg-secondary align-items-center",
                                                    attrs: { role: "group" },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "btn btn-secondary pe-3",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.upVote()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "bi bi-hand-thumbs-up pe-1",
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-none d-md-inline",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "わかりやすい"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              _vm.currentLesson
                                                                .lesson
                                                                .voteValues
                                                            ) +
                                                            "\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "btn btn-secondary border-start ps-2",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downVote()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "bi bi-hand-thumbs-down",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "subtitle" }, [
                                    _c(
                                      "div",
                                      {
                                        class:
                                          !_vm.descriptionShowAll &&
                                          "subtitle-info",
                                      },
                                      [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.markdownParser(
                                                _vm.currentLesson.lesson
                                                  .description
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.currentLesson.lesson.description &&
                                    _vm.currentLesson.lesson.description
                                      .length > 5 &&
                                    !_vm.descriptionShowAll
                                      ? _c(
                                          "button",
                                          {
                                            attrs: {
                                              "aria-label": "もっと見る",
                                              "data-bs-toggle": "modal",
                                              "data-bs-target":
                                                "#subtitleModal",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.descriptionShowAll =
                                                  !_vm.descriptionShowAll
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    ...もっと見る\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "section",
                                { staticClass: "container my-4" },
                                [
                                  _c("CommentContainer", {
                                    staticClass: "p-4",
                                    attrs: {
                                      commentable: _vm.commentable,
                                      user: _vm.user,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("multipane-resizer", {
                          staticStyle: {
                            width: "2px",
                            border: "3px solid rgb(224, 224, 224)",
                            margin: "0 14px 0 -4px",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            ref: "lessonSidebarContainer",
                            staticStyle: { "flex-grow": "1" },
                            attrs: { id: "lessonSidebarContainer" },
                          },
                          [
                            _c(
                              "div",
                              {
                                ref: "lessonSidebar",
                                staticClass: "lesson-side-bar",
                              },
                              [
                                _vm.getBanner("my_lesson_right_sidebar_top")
                                  ? _c("div", {
                                      staticClass: "sidebar-top-banner",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getBanner(
                                            "my_lesson_right_sidebar_top"
                                          ).bodyHtml
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-tabs",
                                  {
                                    model: {
                                      value: _vm.tab,
                                      callback: function ($$v) {
                                        _vm.tab = $$v
                                      },
                                      expression: "tab",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-tab",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.currentLesson.lesson
                                                .lessonType == "live",
                                            expression:
                                              "currentLesson.lesson.lessonType == 'live'",
                                          },
                                        ],
                                        key: "LIVECHAT",
                                        on: {
                                          click: _vm.scrollLiveChatToBottom,
                                        },
                                      },
                                      [_vm._v("LIVECHAT")]
                                    ),
                                    _vm._v(" "),
                                    _vm.currentLessonId &&
                                    _vm.schoolSetting.useAiChatLesson
                                      ? _c(
                                          "v-tab",
                                          {
                                            key: "CHAT",
                                            on: {
                                              click: _vm.scrollChatToBottom,
                                            },
                                          },
                                          [_vm._v("チャット")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentLessonId &&
                                    _vm.schoolSetting.useAiChatLesson
                                      ? _c("v-tab", { key: "THREAD" }, [
                                          _vm._v("スレッド"),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("v-tab", { key: "QA" }, [
                                      _vm._v(
                                        "質問 (" +
                                          _vm._s(
                                            _vm.currentLessonQuestionsCount
                                          ) +
                                          ")"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.courseMaterials.length +
                                      _vm.lessonMaterials.length >
                                    0
                                      ? _c("v-tab", { key: "MATERIAL" }, [
                                          _vm._v(
                                            "素材\n                (" +
                                              _vm._s(
                                                _vm.courseMaterials.length +
                                                  _vm.lessonMaterials.length
                                              ) +
                                              ")\n              "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: { "padding-right": "40px" },
                                    }),
                                    _vm._v(" "),
                                    _vm.schoolSetting &&
                                    _vm.schoolSetting.useAiChatLesson &&
                                    _vm.showCreateThreadBtn
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "btn-new-chat",
                                            attrs: { icon: true },
                                            on: {
                                              click: function ($event) {
                                                return _vm.emitCreateThread(1)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "v-icon material-icons theme--dark",
                                              },
                                              [_vm._v("add_comment")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tabs-items",
                                  {
                                    staticClass: "h-full",
                                    model: {
                                      value: _vm.tab,
                                      callback: function ($$v) {
                                        _vm.tab = $$v
                                      },
                                      expression: "tab",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-tab-item",
                                      {
                                        key: "LIVECHAT",
                                        staticClass: "h-full",
                                      },
                                      [
                                        _vm.currentLesson.lesson.lessonType ==
                                        "live"
                                          ? _c("LiveChat", {
                                              key: "liveChat",
                                              ref: "liveChatContainer",
                                              staticClass: "h-full",
                                              attrs: {
                                                targetableId:
                                                  _vm.currentLessonId ||
                                                  _vm.currentLesson.lesson.id,
                                                targetableType: "Lesson",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.currentLessonId &&
                                    _vm.schoolSetting.useAiChatLesson
                                      ? _c(
                                          "v-tab-item",
                                          {
                                            key: "CHAT",
                                            staticClass: "h-full",
                                          },
                                          [
                                            _c("MesageContainer", {
                                              key: _vm.currentLessonId,
                                              ref: "mesageContainer",
                                              staticClass: "h-full",
                                              attrs: {
                                                targetableId:
                                                  _vm.currentLessonId,
                                                targetableType: "Lesson",
                                                toggleCreateThreadBtn:
                                                  _vm.toggleCreateThreadBtn,
                                                "using-deepseek":
                                                  _vm.schoolSetting
                                                    .usingDeepSeek,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentLessonId &&
                                    _vm.schoolSetting.useAiChatLesson
                                      ? _c(
                                          "v-tab-item",
                                          {
                                            key: "THREAD",
                                            staticClass: "h-full",
                                          },
                                          [
                                            _c("ThreadContainer", {
                                              key: _vm.currentLessonId,
                                              attrs: {
                                                targetableId:
                                                  _vm.currentLessonId,
                                                targetableType: "Lesson",
                                                parentTab: 1,
                                              },
                                              on: {
                                                updateParentTab:
                                                  _vm.updateParentTab,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-tab-item",
                                      { key: "QA", staticClass: "h-full" },
                                      [
                                        _vm.questionMode == "list"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "p-2 bg-white h-full",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "question-list mb-4",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "header" },
                                                      [
                                                        _c("h2", {
                                                          staticClass: "mt-1",
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "UserQuestionDialog",
                                                          {
                                                            attrs: {
                                                              courseId:
                                                                _vm.$route
                                                                  .params
                                                                  .courseId,
                                                              lessonId:
                                                                _vm.currentLesson.lesson.id.toString(),
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-divider", {
                                                      staticClass: "mt-2",
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("UserQuestionList", {
                                                  attrs: {
                                                    "relativeable-type":
                                                      "Lesson",
                                                    "relativeable-id":
                                                      _vm.currentLesson.lesson
                                                        .id,
                                                    onClickQuestion:
                                                      _vm.onClickQuestion,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "px-3 h-full",
                                            staticStyle: {
                                              "overflow-y": "auto",
                                            },
                                          },
                                          [
                                            _vm.questionMode == "show"
                                              ? _c("UserQuestionDetailModal", {
                                                  attrs: {
                                                    question:
                                                      _vm.currentQuestion,
                                                    onBack:
                                                      _vm.onBackQuestionList,
                                                    showCloseButton: false,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      _vm.newQuestionCreatedFlag
                                                        ? {
                                                            key: "notice",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-flex bg-success text-white p-1 justify-content-between align-items-center",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.newQuestionCreatedFlag = false
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("div", [
                                                                      _vm._v(
                                                                        "無事に投稿されました"
                                                                      ),
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("div", [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "bi bi-x-lg",
                                                                      }),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          }
                                                        : null,
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-tab-item", { key: "MATERIAL" }, [
                                      _vm.courseMaterials.length > 0 ||
                                      _vm.lessonMaterials.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "p-2 mb-2 bg-white h-full",
                                              attrs: { flat: "" },
                                            },
                                            [
                                              _vm.courseMaterials.length > 0
                                                ? [
                                                    _c(
                                                      "h5",
                                                      {
                                                        staticClass:
                                                          "border-bottom mt-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "コースの素材一覧"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list",
                                                      {
                                                        staticClass: "mb-5",
                                                        attrs: { dense: "" },
                                                      },
                                                      _vm._l(
                                                        _vm.courseMaterials,
                                                        function (item, index) {
                                                          return _c(
                                                            "v-list-item",
                                                            {
                                                              key: index,
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.downloadFile(
                                                                      item.link
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title"
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.fileName
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-list-item-action",
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "save_alt"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.lessonMaterials.length > 0
                                                ? [
                                                    _c(
                                                      "h5",
                                                      {
                                                        staticClass:
                                                          "border-bottom",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "レッスンの素材一覧"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list",
                                                      { attrs: { dense: "" } },
                                                      _vm._l(
                                                        _vm.lessonMaterials,
                                                        function (item, index) {
                                                          return _c(
                                                            "v-list-item",
                                                            {
                                                              key: index,
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.downloadFile(
                                                                      item.link
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title"
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.fileName
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-list-item-action",
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "save_alt"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
            _vm._v(" "),
            _c("portal", { attrs: { to: "header-left" } }, [
              _c(
                "div",
                { staticClass: "d-flex align-center minus-left" },
                [
                  _c("v-app-bar-nav-icon", {
                    style: _vm.hamburgerColor,
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.leftDrawer = !_vm.leftDrawer
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "header-title",
                      style: { color: _vm.headerNavTextColor },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.headerTitle) + "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("portal", { attrs: { to: "header-center" } }, [
              _c("div", { staticClass: "d-flex align-center" }, [
                _c("div", { staticClass: "d-flex align-center" }, [
                  _c(
                    "div",
                    [
                      _vm.review.body
                        ? _c("ReviewEditDialog", {
                            attrs: {
                              courseId: _vm.$route.params.courseId,
                              review: _vm.review,
                            },
                          })
                        : _c("ReviewDialog", {
                            attrs: { courseId: _vm.$route.params.courseId },
                            on: { updateReview: _vm.updateReview },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ms-2 text-white" }, [
                    _vm._v(
                      "\n            進捗率 " +
                        _vm._s(_vm.proccessCount) +
                        "\n          "
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "portal",
              { attrs: { to: "header-left-drawer" } },
              [
                _c(
                  "v-navigation-drawer",
                  {
                    attrs: { dark: "", fixed: "", app: "" },
                    model: {
                      value: _vm.leftDrawer,
                      callback: function ($$v) {
                        _vm.leftDrawer = $$v
                      },
                      expression: "leftDrawer",
                    },
                  },
                  [
                    _c(
                      "v-toolbar",
                      {
                        staticClass: "cursor-pointer back-home-btn",
                        nativeOn: {
                          click: function ($event) {
                            return _vm.goToHome.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-full d-flex justify-space-between align-center",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "material-icons",
                                staticStyle: { "font-size": "36px" },
                              },
                              [_vm._v("navigate_before")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-grow-1 text-left" },
                              [_vm._v("戻る")]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list",
                      { staticClass: "sidebar-list", attrs: { dense: "" } },
                      [
                        _vm.chapters.length > 0
                          ? [
                              _vm._l(
                                _vm.leftBarItems.filter(function (item) {
                                  return item.type == "header"
                                }),
                                function (item) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: "header-{item.id}",
                                      on: {
                                        click: function ($event) {
                                          return item.action()
                                        },
                                      },
                                    },
                                    [
                                      item.image
                                        ? _c(
                                            "v-list-item-action",
                                            [
                                              _c("v-list-item-avatar", [
                                                _c("img", {
                                                  attrs: { src: item.image },
                                                }),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", {
                                            domProps: {
                                              innerHTML: _vm._s(item.title),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.chapters, function (chapter) {
                                return _c(
                                  "v-list-group",
                                  {
                                    key: chapter.id,
                                    attrs: {
                                      "no-action": "",
                                      color: "white",
                                      value: _vm.leftBarItems
                                        .filter(function (item) {
                                          return item.chapterId == chapter.id
                                        })
                                        .find(function (item) {
                                          return (
                                            item.id.toString() ==
                                            _vm.currentLessonId
                                          )
                                        }),
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        staticClass: "px-0",
                                        attrs: { slot: "activator" },
                                        slot: "activator",
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(chapter.name)),
                                        ]),
                                        _vm._v(" "),
                                        chapter.name.length > 13
                                          ? _c(
                                              "span",
                                              { staticClass: "tooltiptext" },
                                              [_vm._v(_vm._s(chapter.name))]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-group",
                                      _vm._l(
                                        _vm.leftBarItems.filter(function (
                                          item
                                        ) {
                                          return item.chapterId == chapter.id
                                        }),
                                        function (item) {
                                          return _c(
                                            "v-list-item",
                                            {
                                              key: chapter.id + "-" + item.id,
                                              class:
                                                item.id.toString() ===
                                                _vm.currentLessonId.toString()
                                                  ? "v-item--active v-list-item--active"
                                                  : "",
                                              attrs: {
                                                id: "left-bar-item-" + item.id,
                                                "id-value": item.id.toString(),
                                                "current-lesson-id":
                                                  _vm.currentLessonId.toString(),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  item.action
                                                    ? item.action()
                                                    : undefined
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list-item-action",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        item.type !=
                                                        "subheader",
                                                      expression:
                                                        "item.type != 'subheader'",
                                                    },
                                                  ],
                                                },
                                                [
                                                  _c("v-icon", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        item.icon
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              item.image
                                                ? _c(
                                                    "v-list-item-action",
                                                    [
                                                      _c("v-list-item-avatar", [
                                                        _c("img", {
                                                          attrs: {
                                                            src: item.image,
                                                          },
                                                        }),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c("v-list-item-title", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        item.title
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ]
                          : [
                              _c(
                                "v-list-item-group",
                                {
                                  model: {
                                    value: _vm.leftBarSelectedItem,
                                    callback: function ($$v) {
                                      _vm.leftBarSelectedItem = $$v
                                    },
                                    expression: "leftBarSelectedItem",
                                  },
                                },
                                _vm._l(
                                  _vm.leftBarItems,
                                  function (item, index) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: index,
                                        class:
                                          item.id.toString() ==
                                          _vm.currentLessonId.toString()
                                            ? "v-item--active v-list-item--active"
                                            : "",
                                        attrs: {
                                          id: "left-bar-item-" + item.id,
                                          disabled:
                                            item.type == "subheader" ||
                                            item.id.toString() ==
                                              _vm.currentLessonId.toString(),
                                          "id-value": item.id.toString(),
                                          "current-lesson-id":
                                            _vm.currentLessonId.toString(),
                                        },
                                        on: {
                                          click: function ($event) {
                                            item.action
                                              ? item.action()
                                              : undefined
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: item.type == "item",
                                                expression:
                                                  "item.type == 'item'",
                                              },
                                            ],
                                          },
                                          [
                                            _c("v-icon", {
                                              domProps: {
                                                textContent: _vm._s(item.icon),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        item.image
                                          ? _c(
                                              "v-list-item-action",
                                              [
                                                _c("v-list-item-avatar", [
                                                  _c("img", {
                                                    attrs: { src: item.image },
                                                  }),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", {
                                              domProps: {
                                                innerHTML: _vm._s(item.title),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("portal", { attrs: { to: "header-right-drawer" } }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }